import { Grid } from '@mui/material'
import moment from 'moment';
import 'moment/locale/pt-br';

const OutboundDetails = ({ entry }) => {
  moment.locale("pt-br");

  return (
    <>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Descrição:</p>
          <p>{entry?.description ? entry?.description : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Valor(R$):</p>
          <p>{entry?.value ? Number((entry?.value / 100).toFixed(2)).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Data:</p>
          <p>{entry?.dateInvoiced ? moment(entry?.dateInvoiced).format('L') : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85} sx={{ overflowWrap: 'break-word' }}>
          <p className='subTitle'>Conta Bancária:</p>
          <p>{entry?.bankAccount ? entry?.bankAccount : ''}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Projeto:</p>
          <p>{entry?.projectRelated?.title ? entry?.projectRelated?.title : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Empresa:</p>
          <p>{entry?.leadRelated?.businessName ? entry?.leadRelated?.businessName : ''}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Categoria:</p>
          <p>{entry?.category ? entry?.category.name : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Influencer:</p>
          <p>{entry?.subCategories && entry?.subCategories.map((sub) => (sub.name)).join(", ")}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={12} xl={12}>
          <p className='subTitle'>Observações:</p>
          <p>{entry?.miscInfo ? entry?.miscInfo : ''}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Status:</p>
          <p>{entry?.businessStatus ? entry?.businessStatus : ''}</p>
        </Grid>
        {(entry?.withdrawalRelated || entry?.balanceRelated) && (
          <Grid item xs={12} md={5.85} xl={5.85}>
            <p className='subTitle'>Vínculo:</p>
            <p>Criado à partir de um {entry?.withdrawalRelated ? 'saque' : 'saldo'}</p>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default OutboundDetails